import {
  CHECK_EMP_SLOT_TYPES,
  GET_EMP_DEVICES,
  GET_EMP_SLOT,
  GET_EMP_TIME_SLOT,
  VERIFY_UPLOAD_DEVICE_COMMAND_DOC,
  VERIFY_UPLOAD_EMP_DOC,
  VERIFY_EMP_DEVICE,
  SET_EMP_LOCK_DEVICE,
  SEAL_DEVICES,
  UNSEAL_DEVICES,
  CANCEL_BOOK_SLOT,
  START_DEVICE_TESTING,
  VERIFY_MANUAL_TESTING,
  SEND_COMMAND,
  TESTING_DEVICE_ACTV,
  TESTING_DEVICE_HCHK,
  OTHER_INFO,
  VERIFY_OTHER_INFO,
  GET_PBG,
  VERIFY_PBG,
  VERIFY_BG_DETAIL,
  SET_EMPANELED,
  GENERATE_EMPANELED,
  GENERATE_RFC_EMPANELED,
  GET_EMP_RFC_DETAIL,
  VERIFY_EMP_RFC,
  PENDING_RFC_DISTRICT,
  GET_EMP_RFC_EXCEL_DETAIL,
  ACTIVE_TAB,
  GET_EMPANELMENT_OTHER_DOCUMENT,
  SET_EMPANELMENT_OTHER_DOCUMENT,
} from "../actions/AdminTypes";
import {
  GET_EMPANELMENT_DETAIL,
  GET_EMPANELMENT_DOCUMENT,
  GET_BOOKED_TESTING_SLOT,
} from "../actions/types";

const initialState = {
  empDetail: [],
  empDocument: [],
  bookedTestingSlot: [],
  empSlotType: [],
  getEmpSlot: [],
  getEmpTimeSlot: [],
  getEmpDevices: [],
  verifyUploadDoc: [],
  verifyUploadCommandDoc: [],
  verifyEmpDevices: [],
  empLockDevice: [],
  empSealDevice: [],
  empUnSealDevice: [],
  cancelSlot: [],
  startDeviceTest: [],
  verifyDeviceTest: [],
  empSendCommand: [],
  testDeviceActv: [],
  testDeviceHchk: [],
  otherInfoData: [],
  verifyOtherInfoData: [],
  getPbgData: [],
  verifyPbg: [],
  verifyBgData: [],
  setEmpData: [],
  generateEmpData: [],
  generateRfcData: [],
  getEmpRfcData: [],
  verifyRfcDta: [],
  pendingDistrictRfcDta: [],
  rfcExcelData: [],
  activeTabData: "",
};

const empanelmentDetailReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EMPANELMENT_DETAIL:
      return {
        ...state,
        empDetail: payload,
      };
    case GET_EMPANELMENT_DOCUMENT:
      return {
        ...state,
        empDocument: payload,
      };
    case GET_BOOKED_TESTING_SLOT:
      return {
        ...state,
        bookedTestingSlot: payload,
      };
    case CHECK_EMP_SLOT_TYPES:
      return {
        ...state,
        empSlotType: payload,
      };
    case GET_EMP_SLOT:
      return {
        ...state,
        getEmpSlot: payload,
      };
    case GET_EMP_TIME_SLOT:
      return {
        ...state,
        getEmpTimeSlot: payload,
      };
    case GET_EMP_DEVICES:
      return {
        ...state,
        getEmpDevices: payload,
      };
    case VERIFY_UPLOAD_EMP_DOC:
      return {
        ...state,
        verifyUploadDoc: payload,
      };
    case VERIFY_UPLOAD_DEVICE_COMMAND_DOC:
      return {
        ...state,
        verifyUploadCommandDoc: payload,
      };
    case VERIFY_EMP_DEVICE:
      return {
        ...state,
        verifyEmpDevices: payload,
      };
    case SET_EMP_LOCK_DEVICE:
      return {
        ...state,
        empLockDevice: payload,
      };
    case SEAL_DEVICES:
      return {
        ...state,
        empSealDevice: payload,
      };
    case UNSEAL_DEVICES:
      return {
        ...state,
        empUnSealDevice: payload,
      };
    case CANCEL_BOOK_SLOT:
      return {
        ...state,
        cancelSlot: payload,
      };
    case START_DEVICE_TESTING:
      return {
        ...state,
        startDeviceTest: payload,
      };
    case VERIFY_MANUAL_TESTING:
      return {
        ...state,
        verifyDeviceTest: payload,
      };
    case SEND_COMMAND:
      return {
        ...state,
        empSendCommand: payload,
      };
    case TESTING_DEVICE_ACTV:
      return {
        ...state,
        testDeviceActv: payload,
      };
    case TESTING_DEVICE_HCHK:
      return {
        ...state,
        testDeviceHchk: payload,
      };
    case OTHER_INFO:
      return {
        ...state,
        otherInfoData: payload,
      };
    case VERIFY_OTHER_INFO:
      return {
        ...state,
        verifyOtherInfoData: payload,
      };
    case GET_PBG:
      return {
        ...state,
        getPbgData: payload,
      };
    case VERIFY_PBG:
      return {
        ...state,
        verifyPbg: payload,
      };
    case VERIFY_BG_DETAIL:
      return {
        ...state,
        verifyBgData: payload,
      };
    case SET_EMPANELED:
      return {
        ...state,
        setEmpData: payload,
      };
    case GENERATE_EMPANELED:
      return {
        ...state,
        generateEmpData: payload,
      };
    case GENERATE_RFC_EMPANELED:
      return {
        ...state,
        generateRfcData: payload,
      };
    case GET_EMP_RFC_DETAIL:
      return {
        ...state,
        getEmpRfcData: payload,
      };
    case VERIFY_EMP_RFC:
      return {
        ...state,
        verifyRfcDta: payload,
      };
    case PENDING_RFC_DISTRICT:
      return {
        ...state,
        pendingDistrictRfcDta: payload,
      };
    case GET_EMP_RFC_EXCEL_DETAIL:
      return {
        ...state,
        rfcExcelData: payload,
      };
    case ACTIVE_TAB:
      return {
        ...state,
        activeTabData: payload,
      };
    case GET_EMPANELMENT_OTHER_DOCUMENT:
      return {
        ...state,
        otherEmpDoc: payload,
      };
    case SET_EMPANELMENT_OTHER_DOCUMENT:
      return {
        ...state,
        empDocData: payload,
      };

    default:
      return state;
  }
};

export { empanelmentDetailReducer };
